$( document ).ready(function() {
  // App Settings
  const animationSpeed = '1'; // Animation speed in seconds
  const animationDelay = '250'; // Time between multiple animations in ms
  
  
  // Class Definitions
  const sbtOptionWrapperClass = '.tcw-sbt-filter-options';
  const sbtOptionClass = '.tcw-sbt-filter-option';
  
  const sbtSlideWrapperClass = '.tcw-sbt-filter-slideshow-wrapper';
  const sbtSlideClass = '.tcw-sbt-filter-slideshow-slide'

  // Element Selectors
  const optionWrapper = $(sbtOptionWrapperClass);
  const options = $(sbtOptionClass);
  
  const slideWrapper = $(sbtSlideWrapperClass);
  const slides = $(sbtSlideClass);

  var switchLock = 0;

  $(sbtSlideClass+":not(.active)").hide();

  // Filter Option click function
  options.click(function(e){
    if(switchLock) { return false; }
    switchLock = 1;
    
    let filterIndex = $(this).data('filter-index');
    let newSlides = slideWrapper.find(sbtSlideClass+'[data-filter-index="'+filterIndex+'"]');
    let addNew = true;

    options.removeClass('active');
    $(this).addClass('active');

    slidesAnimOut(addNew,newSlides);
  });

  function slidesAnimOut(addNew,newSlides) {
    let active = slideWrapper.find(sbtSlideClass+'.active');
    
    active.each(function(index) {
      let curSlide = this;
      let last = (index == (active.length - 1));
      
      setTimeout(function() {
        $(curSlide).addClass('inactive');
      }, index * animationDelay);

      if(!addNew) {
        setTimeout(function() {
          active.hide();
          slidesAnimIn(newSlides);
        }, animationSpeed * 1000);
      }      
      
      if(last) {
        if(!addNew) {
          setTimeout(function() {
            switchLock = 0;
          }, animationSpeed * 1000);          
        } else {
          setTimeout(function() {
            active.hide();
            slideWrapper.find(sbtSlideClass+'.inactive').removeClass('inactive active');
            slidesAnimIn(newSlides);
          }, animationSpeed * 1000);          
        }
      }
    });
  }
  
  function slidesAnimIn(newSlides) {
    newSlides.show();
    newSlides.each(function(index) {
      let last = (index == (newSlides.length - 1));
      let curSlide = this;
      
      setTimeout(function() {
        $(curSlide).addClass('active');
      }, index * animationDelay);

      if(last) {
        setTimeout(function() {
          switchLock = 0;
        }, index * animationDelay);
      }
    });
  }
  
});